module.exports = {"623027100":"拉卜楞镇","623027101":"王格尔塘镇","623027102":"阿木去乎镇","623027103":"桑科镇","623027104":"甘加镇","623027105":"麻当镇","623027106":"博拉镇","623027107":"科才镇","623027202":"达麦乡","623027204":"曲奥乡","623027205":"唐尕昂乡","623027206":"扎油乡","623027208":"吉仓乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623027.json
// module id = 3117
// module chunks = 0